// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: 20,
    /* Optional */
    // loadProductFirst: true,
  },
};

const addToCompareIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" viewBox="0 0 48 48">
<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" transform="translate(3 16)">
    <ellipse cx="10.5" cy="10.744" stroke="#003A81" rx="10.5" ry="10.744"/>
    <path stroke="#7F9CC0" stroke-dasharray="4" d="M22.5 21.744c5.799 0 10.5-4.7 10.5-10.5 0-5.799-4.701-10.5-10.5-10.5S12 5.445 12 11.244c0 5.8 4.701 10.5 10.5 10.5z"/>
</g>
</svg>
`;

const quickShopAddButton = `<button class="cta-button cta-button--blue mb-3 {{itemUnavailableForQuickshop}}" v-on:click="addToQuickShop('{{itemHandle}}')"><p class="cta-button__text">Quickshop</p></button>`;

const requestSamplesButton = `<button id="{{productCardID}}" class="add-to-samples-cta cta-button cta-button--green hide" {{itemUnavailableForSamples}} v-on:click="(e) => addCollectionProductToSamples(e)"><p class="cta-button__text"></p></button>`;

const discountBanner = `{{itemDiscountBanner}}`;

const productGridSnippet = `<div class="prod-card" data-product-handle="{{itemHandle}}" data-product-id="{{itemId}}" {{sampleData}} {{itemStockData}}>
                              <div class="prod-card__sample-selected">
                              <img class="prod-card__sample-selected-img" src="${window.Shopify.assetBaseUrl}ui-selected.svg">
                              </div>
                              <div class="prod-card__banner">
                                {{itemBadge}}
                              </div>
                              <div class="prod-card__wrapper">
                                <div class="prod-card__img-wrapper">
                                  <div class="prod-card__overlay">
                                    <div class="prod-card__overlay-button-wrap">
                                      ${quickShopAddButton}
                                      ${requestSamplesButton}
                                    </div>
                                  </div>
                                  <img class="prod-card__img lazyload" data-src="{{itemThumbUrl}}">

                                  ${discountBanner}
                                </div>
                                <a href="/products/{{itemHandle}}">
                                  <div class="prod-card__title">{{itemTitle}}</div>
                                </a>
                                <div class="prod-card__rating"><div class="drop-rating__wrapper"><div class="drop-rating__ratings">{{itemDropletRating}}</div></div></div>
                                <div class="prod-card__rating" data-bv-show="inline_rating" data-bv-product-id="{{itemId}}" data-bv-redirect-url="/products/{{itemHandle}}" data-bv-seo="false"></div>
                                <div class="prod-card__seperator"></div>
                                <h3 class="prod-card__price">{{itemPrice}}</h3>
                                <div class="prod-card__pack">{{itemProductQTY}}</div>
                                <div class="prod-card__weight">{{itemProductWeight}}</div>
                                <div class="prod-card__stock-badge">{{itemStockBadge}}</div>

                                <div class="prod-card__quick-shop prod-card__quick-shop--mobile">
                                  ${quickShopAddButton}
                                  ${requestSamplesButton}
                                </div>

                                <button v-if="!isSelected['{{productCardID}}']" v-on:click="addToCompareList('{{preparedData}}')" class="button button--compare no-transform prod-card__compare">
                                  <div class="prod-card__compare-icon">${addToCompareIcon}</div>
                                  <span>Add to compare</span>
                                </button>
                                <button v-else v-on:click="removeFromCompareList('{{productCardID}}')" class="button button--compare no-transform prod-card__compare">
                                  <div class="prod-card__compare-icon">${addToCompareIcon}</div>
                                  <span>Remove from compare</span>
                                </button>
                              </div>
                            </div>`;

const paginationArrowRight = `<svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" class="pagination-arrow">
<path fill="none" fill-rule="evenodd" stroke="#003A81" stroke-width="2px" stroke-linecap="round" stroke-linejoin="round" d="M8.5 5L15.5 12 8.5 19" transform="matrix(1 0 0 1 0 0)"/>
</svg>
`;

const paginationArrowLeft = `<svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" class="pagination-arrow">
<path fill="none" fill-rule="evenodd" stroke="#003A81" stroke-width="2px" stroke-linecap="round" stroke-linejoin="round" d="M8.5 5L15.5 12 8.5 19" transform="matrix(-1 0 0 1 24 0)"/>
</svg>
`;

// Declare Templates
var bcSfFilterTemplate = {
  soldOutClass: 'sold-out',
  saleClass: 'on-sale',
  soldOutLabelHtml: '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
  saleLabelHtml: '<div>' + bcSfFilterConfig.label.sale + '</div>',
  vendorHtml: '<div>{{itemVendorLabel}}</div>',

  // Grid Template
  productGridItemHtml: productGridSnippet,

  // Pagination Template
  previousActiveHtml: `<li class="item"><a href="{{itemUrl}}" class="item-prev item-prev-link">${paginationArrowLeft}</a></li>`,
  previousDisabledHtml: `<li class="item disabled"><span class="item-prev">${paginationArrowLeft}</span></li>`,
  nextActiveHtml: `<li class="item"><a href="{{itemUrl}}" class="item-next item-next-link">${paginationArrowRight}</a></li>`,
  nextDisabledHtml: `<li class="item disabled"><span class="item-next">${paginationArrowRight}</span></li>`,
  pageItemHtml: '<li class="item"><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml:
    '<li class="item selected"><span class="active">{{itemTitle}}</span></li>',
  pageItemRemainHtml: '<li class="item"><span>{{itemTitle}}</span></li>',
  paginateHtml:
    '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
  sortingHtml:
    '<select id="bc-sf-filter-top-sorting-select" name="collection-sort__input" class="collection-sort__input custom-styled-dropdown">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
  /*** Prepare data ***/
  var images = data.images_info;

  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices

  // Display the Product Option Called QTY
  var productOptionQtyValue = data.options_with_values.filter(
    (option) => option.name == 'qty'
  );
  productOptionQtyValue = productOptionQtyValue[0]
    ? productOptionQtyValue[0].values[0].title
    : '';

  var firstVariant = data['variants'][0];

  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function (e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }

  var preparedData = {
    id: data['id'],
    handle: data['handle'],
    title: encodeURIComponent(data['title']),
    image:
      images.length > 0
        ? this.optimizeImage(images[0]['src'])
        : bcSfFilterConfig.general.no_image_url,
    tags: data['tags'].length > 0 ? data['tags'] : [],
  };
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  // Add Thumbnail
  var itemThumbUrl =
    images.length > 0
      ? this.optimizeImage(images[0]['src'])
      : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
  itemHtml = itemHtml.replace(
    /{{preparedData}}/g,
    btoa(JSON.stringify(preparedData))
  );
  itemHtml = itemHtml.replace(/{{productCardID}}/g, data['id']);
  itemHtml = itemHtml.replace(/{{productVariantID}}/g, data['variants'][0].id);
  const sampleId = data.metafields.find((metafield) => metafield?.key === 'linked_sample' && metafield?.namespace === 'global')?.value;
  if (sampleId) {
    const sampleIdData = `data-sample-id="${sampleId}"`;
    itemHtml = itemHtml.replace(/{{sampleData}}/g, sampleIdData);
    itemHtml = itemHtml.replace(/{{itemProductWeight}}/g, '');
  } else if (data.title.toLocaleLowerCase().includes('sample')) {
    const isKit = data.metafields.find((metafield) => metafield?.key === 'is_sample_kit' && metafield?.namespace === 'global')?.value === "true" || false;  
    const weight = Number(data.metafields.find((metafield) => metafield?.key === 'sample_kit_weight' && metafield?.namespace === 'global')?.value || (isKit ? 3 : 1));
    const variantIds = data.variants.map((variant) => variant.id).join(',');
    itemHtml = itemHtml.replace(/{{sampleData}}/g, `data-sample-kit="${isKit}" data-sample-weight="${weight}" data-sample-handle="${data.handle}" data-sample-tags="${data.tags}" data-sample-variant-id="${data.variants[0].id}" data-sample-variant-ids="${variantIds}"`);
    if (weight > 1) {
      itemHtml = itemHtml.replace(/{{itemProductWeight}}/g, `Equivalent of ${weight} Individual Samples`);
    } else {
      itemHtml = itemHtml.replace(/{{itemProductWeight}}/g, '');
    }
  } else {
    itemHtml = itemHtml.replace(/{{sampleData}}/g, '');
    itemHtml = itemHtml.replace(/{{itemProductWeight}}/g, '');
  }
  // Add Price
  var itemPriceHtml = '';
  if (data.title != '') {
    itemPriceHtml += `<span class="prod-card__meta ${
      onSale ? 'text--orange' : ''
    }">`;
    if (data.price_min !== 0) {
      if (priceVaries) {
        // itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{price}}/g, this.formatMoney(data.price_min * 100));
        itemPriceHtml += `${this.formatMoney(data.price_min * 100)}`;
      } else {
        itemPriceHtml += this.formatMoney(data.price_min * 100);
      }
    } else {
      itemPriceHtml += "FREE";
    }
    if (onSale) {
      itemPriceHtml += `<small class="sale_price"><s>${this.formatMoney(
        data.compare_at_price_min * 100
      )}</s></small>`;
    }
    itemPriceHtml += '</span>';
  }
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add onSale class
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

  // Add soldOut Label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

  // Add onSale Label
  var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

  // Add Vendor
  var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable
    ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
    : '';
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Add Product Card Badge - ie. Sale, New, Best Seller
  itemHtml = itemHtml.replace(
    /{{itemBadge}}/g,
    this.buildProductCardBadge(data)
  );

  // Add Product Option called QTY - Display the Title
  itemHtml = itemHtml.replace(/{{itemProductQTY}}/g, productOptionQtyValue);

  // Add Product Droplet Rating
  itemHtml = itemHtml.replace(
    /{{itemDropletRating}}/g,
    this.buildProductCardDroplets(data)
  );

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  // Check if the product is available for sampling
  itemHtml = itemHtml.replace(
    /{{itemUnavailableForSamples}}/g,
    this.checkProductSampleAvailablity(data)
  );
  // Check if Quick Shop is disabled for the product
  itemHtml = itemHtml.replace(
    /{{itemUnavailableForQuickshop}}/g,
    this.checkIfQuickShopDisabled(data)
  );

  // Build the discount banner - pulls product & global metafields
  itemHtml = itemHtml.replace(
    /{{itemDiscountBanner}}/g,
    this.buildDiscountBanner(data)
  );

  // Build stock-by-state badge and data attribute
  var stockByState = this.getProductMetafieldValue(data.metafields, 'stock_by_state');
  if (stockByState) {
    var stockJSON = typeof stockByState === 'string' ? stockByState : JSON.stringify(stockByState);
    itemHtml = itemHtml.replace(/{{itemStockData}}/g, 'data-stock-by-state=\'' + stockJSON.replace(/'/g, '&#39;') + '\'');
  } else {
    itemHtml = itemHtml.replace(/{{itemStockData}}/g, '');
  }
  itemHtml = itemHtml.replace(/{{itemStockBadge}}/g, this.buildStockBadge(data));

  return itemHtml;
};

// Custom - WeRD Build stock-by-state badge for PLP
BCSfFilter.prototype.buildStockBadge = function (data) {
  var stockMeta = this.getProductMetafieldValue(data.metafields, 'stock_by_state');
  if (!stockMeta) return '';

  var stockData;
  try {
    stockData = typeof stockMeta === 'string' ? JSON.parse(stockMeta) : stockMeta;
  } catch (e) { return ''; }

  var state = window.GlobalState ? window.GlobalState.getEffectiveState() : null;
  if (!state) {
    return '<span class="prod-card__stock-badge prod-card__stock-badge--no-state">Select state for availability</span>';
  }

  var available = !!stockData[state];
  if (available) {
    return '<span class="prod-card__stock-badge prod-card__stock-badge--in-stock">In Stock</span>';
  }
  return '<span class="prod-card__stock-badge prod-card__stock-badge--oos">Out of Stock</span>';
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
  // // Add Description
  // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  // // Truncate by word
  // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
  // // Truncate by character
  // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
  // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {
  for (var k in data) {
    // Add Options
    var optionsArr = [];
    for (var i in data[k]['options_with_values']) {
      optionsArr.push(data[k]['options_with_values'][i]['name']);
    }
    data[k]['options'] = optionsArr;

    // Customize variants
    for (var i in data[k]['variants']) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]['variants'][i];
      // Add Options
      var variantOptions = variant['merged_options'];
      if (Array.isArray(variantOptions)) {
        for (var j = 0; j < variantOptions.length; j++) {
          var temp = variantOptions[j].split(':');
          data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
          data[k]['variants'][i]['option_' + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
        data[k]['variants'][i]['options'] = variantOptionArr;
      }
      data[k]['variants'][i]['compare_at_price'] =
        parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
      data[k]['variants'][i]['price'] =
        parseFloat(data[k]['variants'][i]['price']) * 100;
    }

    // Add Description
    data[k]['description'] = data[k]['body_html'];
  }
  return data;
};

// Custom - WeRD Build the Product Card Badge: New, Best Seller, Sale
BCSfFilter.prototype.buildProductCardBadge = function (data) {
  var html = '';
  var hasFlag = false;
  var flagType = '';
  var flagLabel = '';
  var flagClassName = '';
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale

  // Sale Tag take precedence over the tags themselves
  if (onSale) {
    hasFlag = true;
    flagLabel = 'Sale';
    flagClassName = 'sale';
  } else {
    for (var i = 0; i < data['tags'].length; i++) {
      var tagHandle = data['tags'][i];
      if (tagHandle.match('^badge')) {
        hasFlag = true;
        flagType = tagHandle.split('badge:');
        flagLabel = flagType[1];
        flagClassName = flagType[1].toLowerCase().replace(' ', '-');
        // Set order of priority and break loop
        if (
          flagClassName === 'sale' ||
          flagClassName === 'best-seller' ||
          flagClassName === 'new'
        ) {
          break;
        }
      }
    }
  }

  if (hasFlag && flagLabel) {
    html = `<span class="prod-card__banner-badge prod-card__banner-badge--${flagClassName}">${flagLabel}</span>
            <span class="prod-card__banner-background prod-card__banner-background--${flagClassName}"></span> `;
  }
  return html;
};

// Custom - WeRD Build the Droplet Rating within the Product Card
BCSfFilter.prototype.buildProductCardDroplets = function (data) {
  let rating = '0';
  let baseAssetUrl = window.Shopify.assetBaseUrl;
  let halfDropSVG = 'ui-icon-drip-half.svg';
  let fullDropSVG = 'ui-icon-drip-full.svg';
  let emptyDropSVG = 'ui-icon-drip-empty.svg';
  let ratingHTML = '';

  // Loop over the Tags to collection the Absorbency Value
  data.tags
    .filter((tag) => tag.includes('absorbency_rating:'))
    .map((tag) => {
      let val = tag.split(':');
      rating = val[1].toString();
    });

  // Loop over the Droplets and Append Appropriate Img
  for (let $i = 0; $i < 8; $i++) {
    let halfDrop = $i + 0.5;

    if (parseFloat(rating) == halfDrop) {
      ratingHTML += `<img class="drop-rating__icon" src="${
        baseAssetUrl + halfDropSVG
      }">`;
    } else if (parseFloat(rating) > $i) {
      ratingHTML += `<img class="drop-rating__icon" src="${
        baseAssetUrl + fullDropSVG
      }">`;
    } else {
      ratingHTML += `<img class="drop-rating__icon" src="${
        baseAssetUrl + emptyDropSVG
      }">`;
    }
  }

  // Return The Rating
  return ratingHTML;
};

// Custom - WeRD Check if the product is available
BCSfFilter.prototype.checkProductSampleAvailablity = function (data) {
  /**
   * Check the product tags whether or not the
   * 'disable_product_samples' exists. If it does, hide the HTML Element.
   * Note: this tag is automatically generated by a checkbox within the
   * Accentuate Custom Metafield Shopify App
   */
  const { tags } = data;
  if (!tags) {
    return '';
  }

  const sampleId = data.metafields.find((metafield) => metafield?.key === 'linked_sample' && metafield?.namespace === 'global')?.value;

  const hideSampingCTA = tags.some((tag) => tag === 'disable_product_samples');
  return hideSampingCTA ? 'data-item-unavailable-for-samples' : sampleId ? '' : 'data-item-unavailable-for-samples';
};
// Custom - WeRD Check if Quick Shop is disabled
BCSfFilter.prototype.checkIfQuickShopDisabled = function (data) {
  /**
   * Check the product tags whether or not the
   * 'disable_quickshop' exists. If it does, hide the HTML Element.
   * Note: this tag is automatically generated by a checkbox within the
   * Accentuate Custom Metafield Shopify App
   */
  const { tags, title } = data;
  if (!tags) {
    return '';
  }
  const hideQuickshopCTA = tags.some((tag) => tag === 'disable_quickshop');
  return hideQuickshopCTA ? 'hide' : '';
};
// Custom - WeRD function to build out the discount banner
BCSfFilter.prototype.buildDiscountBanner = function (data) {
  const { metafields } = data;
  let ratingHTML = '';
  const productDiscountText = this.getProductMetafieldValue(
    metafields,
    'discount_message'
  );
  const productDiscountTextColor = this.getProductMetafieldValue(
    metafields,
    'discount_text_colour'
  );
  const productDiscountBackground = this.getProductMetafieldValue(
    metafields,
    'discount_banner_colour'
  );

  // Set the Discount Badge text, color and background.
  // First priority is to display the product metafields
  // Then, the global metafields
  // Else, nothing.
  if (window.theme && window.theme.bcSF) {
    const { globalProductCardDiscountBadge } = window.theme.bcSF;
    const { text, textColor, background } = globalProductCardDiscountBadge;

    const discountText = productDiscountText || text;
    const discountTextColor = productDiscountTextColor || textColor;
    const discountBackground = productDiscountBackground || background;

    if (discountText && discountTextColor && discountBackground) {
      ratingHTML = `<div class="prod-card__discount-banner"><div class="product-hero__details-form__discount-message" style="color:${discountTextColor}; background-color:${discountBackground}"><p>${discountText}</p></div></div>`;
    }
  }

  // Return the discount banner
  return ratingHTML;
};

// Custom - WeRD function to return product metafield value
BCSfFilter.prototype.getProductMetafieldValue = function (
  metafields,
  metafieldKey
) {
  const metafield =
    metafields && metafields.find((item) => item.key === metafieldKey);
  return metafield ? metafield.value : false;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
  if (this.getSettingValue('general.paginationType') == 'default') {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
      jQ(this.selector.bottomPagination).html('');
      return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = bcSfFilterTemplate.paginateHtml;

      // Build Previous
      var previousHtml =
        currentPage > 1
          ? bcSfFilterTemplate.previousActiveHtml
          : bcSfFilterTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink('page', currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml =
        currentPage < totalPage
          ? bcSfFilterTemplate.nextActiveHtml
          : bcSfFilterTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink('page', currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? bcSfFilterTemplate.pageItemSelectedHtml
              : bcSfFilterTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          this.buildToolbarLink('page', currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      jQ(this.selector.bottomPagination).html(paginationHtml);
    }
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '<option selected>Sort By</option>';

      for (var k in sortingArr) {
        sortingItemsHtml +=
          '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      );
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Display type (List / Grid / Collage)
BCSfFilter.prototype.buildFilterDisplayType = function () {
  var itemHtml =
    '<a href="' +
    this.buildToolbarLink('display', 'list', 'grid') +
    '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml +=
    '<a href="' +
    this.buildToolbarLink('display', 'grid', 'list') +
    '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  jQ(this.selector.topDisplayType).html(itemHtml);

  // Active current display type
  jQ(this.selector.topDisplayType)
    .find('.bc-sf-filter-display-list')
    .removeClass('active');
  jQ(this.selector.topDisplayType)
    .find('.bc-sf-filter-display-grid')
    .removeClass('active');
  if (this.queryParams.display == 'list') {
    jQ(this.selector.topDisplayType)
      .find('.bc-sf-filter-display-list')
      .addClass('active');
  } else if (this.queryParams.display == 'grid') {
    jQ(this.selector.topDisplayType)
      .find('.bc-sf-filter-display-grid')
      .addClass('active');
  }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
  // Style Dropdown
  $('select.custom-styled-dropdown').niceSelect();

  // Build out the item count
  let numOfFilteredProducts;
  data.total_product > 1
    ? (numOfFilteredProducts = `${data.total_product} Items`)
    : (numOfFilteredProducts = `${data.total_product} Item`);
  $('.bc-sf-search-result-number').html(numOfFilteredProducts);

  // Product Compare Module
  window.compare();
  window.decorateProductCardsWithSampleData();

  // Update PLP stock badges
  if (typeof window.updatePlpStockBadges === 'function') {
    window.updatePlpStockBadges();
  }
};
